import { HttpInterceptorFn } from '@angular/common/http';

import { IsFormDataEnabled } from '../context';

export const contextHeaderInterceptor: HttpInterceptorFn = (req, next) => {
  return next(
    req.clone({
      setHeaders: {
        Accept: 'application/json',
        ...(!req.context.get(IsFormDataEnabled) && { 'Content-Type': 'application/json' })
      }
    })
  );
};
